import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import VisualCanvas from './VisualCanvas';

const CategoriesSection = () => {
    const categories = [
        ["Website Design", "Mobile Apps", "Android Apps", "iPhone Apps", "Software Architecture", "Graphic Design", "Logo Design", "Public Relations", "Logistics", "Proofreading", "Translation", "Research"],
        ["Research Writing", "Article Writing", "Web Scraping", "HTML", "CSS", "HTML 5", "Javascript", "Data Processing", "Python", "Wordpress", "Web Search", "Finance"],
        ["Legal", "Linux", "Manufacturing", "Data Entry", "Content Writing", "Marketing", "Excel", "Ghostwriting", "Copywriting", "Accounting", "MySQL", "C++ Programming"],
        ["Banner Design", "Illustration", "Link Building", "C# Programming", "PHP", "3D Modelling", "Photoshop", "Technical Writing", "Blogging", "Internet Marketing", "eCommerce"]
    ];

    return (
        <section className="py-20 md:py-44 min-h-[auto] md:min-h-screen flex items-center bg-white text-slate-900 overflow-hidden border-y border-slate-100 relative">
            {/* Background 3D */}
            <div className="absolute inset-x-0 top-0 bottom-0 opacity-[0.03] pointer-events-none">
                <VisualCanvas type="torus" color="#2563eb" height="100%" />
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="flex flex-col lg:flex-row gap-8 lg:gap-20">
                    {/* Left Side: Title */}
                    <div className="lg:w-1/3 relative">
                        <div className="absolute -left-8 top-0 bottom-0 w-[2px] bg-gradient-to-b from-primary via-primary/50 to-transparent hidden xl:block">
                            <div className="absolute top-10 -left-[3px] w-2 h-2 bg-primary rounded-full shadow-[0_0_15px_#2563eb] flex items-center justify-center">
                                <div className="w-1 h-1 bg-white rounded-full"></div>
                            </div>
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="text-2xl md:text-3xl lg:text-4xl font-black leading-[1.2] tracking-tight text-slate-900"
                        >
                            Get work done in <br />
                            <span className="text-gradient font-black">over 2700</span> <br />
                            different <br />
                            categories
                        </motion.h2>
                    </div>

                    {/* Right Side: Grid of Categories */}
                    <div className="lg:w-2/3 grid grid-cols-2 lg:grid-cols-4 gap-x-6 md:gap-x-10 gap-y-3 md:gap-y-4">
                        {categories.map((column, colIdx) => (
                            <div key={colIdx} className="space-y-2 md:space-y-2.5">
                                {column.map((item, itemIdx) => (
                                    <motion.div
                                        key={itemIdx}
                                        initial={{ opacity: 0, y: 10 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: (colIdx * 0.1) + (itemIdx * 0.05) }}
                                        className="group cursor-pointer"
                                    >
                                        <p className="text-[11px] md:text-sm font-bold text-slate-500 group-hover:text-primary transition-all duration-300 group-hover:translate-x-1">
                                            {item}
                                        </p>
                                    </motion.div>
                                ))}
                                {colIdx === categories.length - 1 && (
                                    <motion.div
                                        initial={{ opacity: 0, y: 10 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        className="inline-flex items-center gap-1.5 text-primary font-black uppercase tracking-widest text-[9px] md:text-xs cursor-pointer hover:gap-3 transition-all mt-2"
                                    >
                                        View more <ArrowRight size={14} />
                                    </motion.div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CategoriesSection;
